import { exp } from "./export";
import { lang } from '../lang.js';
import { beads } from '../beads.js';
import { settings } from '../settings.js';

exp.getSquareStrips = () => {
    let result = {
        rows: []
    };

    for (let i = 1; i < settings.rows + 1; i++) {

        let myBeads = beads.arr.filter(bead => {
            if (!bead.star) return false;
            return bead.star.row == i;
        }).map(bead => exp.getNewBead(bead));
        myBeads.unshift(myBeads.pop());
        result.rows.push(myBeads);
    }

    return [result];
};

exp.getStarStrips = () => {
    let result = [];

    for (let sq = 1; sq < 6; sq++) {

        let obj = {
            rows: [],
            stripNumber: sq
        };

        for (let i = 1; i < settings.rows + 1; i++) {

            let startBeads = beads.arr.filter(bead => {
                if (!bead.star) return false;
                return (bead.star.row == i) && (bead.star.square == sq);
            });

            // split into four

            let row1 = startBeads.slice(0, i);
            let row2 = startBeads.slice(i, i * 2);
            let row3 = startBeads.slice(i * 2, i * 3);
            let row4 = startBeads.slice(i * 3, i * 4);

            // reverse order of two of the sides

            row1 = row1.reverse();
            row2 = row2.reverse();

            // recombine in different order

            let beads3 = row2.concat(row4).concat(row3).concat(row1);

            let myBeads = beads3.map(bead => exp.getNewBead(bead));

            myBeads.unshift(myBeads.pop());
            obj.rows.push(myBeads);
        }

        result.push(obj);
    }

    return result;
};

exp.getSquareWordChart = strip => { // used for both warp square and peyote star

    let result = {text: []};

    exp.hasBlanks = false;

    strip.rows.forEach((row, i) => {

        let rowNumber = i + 1;

        result.text.push(lang.caps(lang.get('row')) + ' ' + + rowNumber.toString() + ':');

        result.text.push('\n');

        if (i == 0) {
            result.text.push('(');
            exp.parseRow(row).forEach(element => {
                result.text.push(element);
            });
            result.text.push(')');
            result.text.push('\n');
        } else if (i == strip.rows.length - 1 && settings.pattern.name == 'star') {
            // joining row of peyote star

            // split rows up into 4 subrows
            let subRows = [];
            let subRowLen = rowNumber;
            for (let j = 0; j < 4; j++) {
                subRows.push(row.slice(j * subRowLen, (j * subRowLen) + subRowLen))
            }

            subRows[0].shift(); // remove non-existent star point bead
            subRows[1].splice(1, 1);

            // process first two subrows
            [0, 1].forEach(num => {
                let r = subRows[num];

                // chunk first bead
                result.text.push('(');
                exp.parseRow(r.slice(0,1)).forEach(element => {
                    result.text.push(element);
                });
                result.text.push('), ');

                // deal with rest of subrow
                exp.parseRow(r.slice(1)).forEach(element => {
                    result.text.push(element);
                });

                result.text.push('\n');
            });

            // add final star center bead

            result.text.push('(');
            exp.parseRow([subRows[2][0]]).forEach(element => {
                result.text.push(element);
            });
            result.text.push(')');

            result.text.push('\n');

        } else {
            // split rows up into 4 subrows
            let subRows = [];
            let subRowLen = rowNumber;
            for (let j = 0; j < 4; j++) {
                subRows.push(row.slice(j * subRowLen, (j * subRowLen) + subRowLen))
            }

            // process subrows
            subRows.forEach(r => {
                // chunk first two beads
                result.text.push('(');
                exp.parseRow(r.slice(0,2)).forEach(element => {
                    result.text.push(element);
                });

                if (i > 1) {
                    result.text.push('), ');
                    // deal with rest of subrow
                    exp.parseRow(r.slice(2)).forEach(element => {
                        result.text.push(element);
                    });
                } else {
                    result.text.push(')');
                }
                result.text.push('\n');
            });
        }
        result.text.push('\n');
    });

    if (exp.hasBlanks) result.text.push({
        text: '\n* = ' + lang.get('space between beads explanation on pdf export', 'space between beads')
    });

    return result;
};